import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const ErrorMessage = styled.div`
  text-align: center;
  color: #f00;
  margin-bottom: 35px;
  margin-top: 20px;
  &.after-single-checker {
    margin-top: -20px;
  }
  ${media.tabletP`
    margin-top: 0;
    &.after-single-checker {
      margin-top: 0;
    }
    margin-bottom: 20px;
  `};
`;

export const SingleCheckerWrapCol3 = styled.div`
  > div {
    > div {
      width: 100%;
      ${media.tabletP`
        width: 33.3333%;
      `};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/StylistDiagnosisPage/StylistDiagnosisPage.style.js